// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__keQBCQHWCP{width:600px}`, "",{"version":3,"sources":["webpack://./src/app/components/appModals/components/automationModal/automationModal.module.scss"],"names":[],"mappings":"AAEA,kBACE,WAAA","sourcesContent":["@use '@dixa/lib-shared-tokens/scss' as *;\n\n.root {\n  width: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__keQBCQHWCP`
};
export default ___CSS_LOADER_EXPORT___;
